import { z } from 'zod';

export const WorkspaceTopTaskCategoryFilterSchema = z.object({
  SubmissionNeeded: z.boolean(),
  TalentNearingIdle: z.boolean(),
  TalentCheckIn: z.boolean(),
  TalentCooling: z.boolean(),
  TalentBioIssues: z.boolean(),
  TalentFeedback: z.boolean(),
  TalentOnboarding: z.boolean(),
  snoozedTasks: z.boolean(),
});

export type WorkSpaceTopTaskCategoryFilter = z.infer<
  typeof WorkspaceTopTaskCategoryFilterSchema
>;
